import { Box, Typography } from '@mui/material'
import React from 'react'

import PatientFormDisclaimer from './PatientFormDisclaimer'
import { PatientFormHeaderProps } from './_props'
import useStyles from './_styles/PatientFormStyles'
import { usePatientIdentity } from './services/usePatientUtils'
import { usePatientFormContext } from '../context/PatientFormContext'
import DowngradeIdentityDialog from './PatientIdentity/DowngradeIdentityDialog'

const PatientFormHeader = ({ title, formDisclaimerProps, onDowngrade }: PatientFormHeaderProps) => {
    const classes = useStyles()
    const { currentIdentityStatusSlug } = usePatientIdentity()
    const { state } = usePatientFormContext()

    return (
        <div className={classes.PatientFormHeader}>
            <div className={classes.PatientFormHeaderTexts}>
                <Box className={classes.PatientFormHeaderTitleContainer}>
                    <Typography className={classes.PatientFormHeaderTitle}>{title}</Typography>
                    <DowngradeIdentityDialog
                        isDowngraded={state.isIdentityDowngraded}
                        currentIdentityStatusSlug={currentIdentityStatusSlug}
                        onDowngrade={onDowngrade}
                    />
                </Box>
                <Typography className={classes.PatientFormHeaderSubTitle}>Modifier les informations patient</Typography>
            </div>

            <PatientFormDisclaimer {...formDisclaimerProps} />
        </div>
    )
}

export default PatientFormHeader
